export const siteConfig = {
  name: "Laurel Web Co.",
  division: "a division of Becoming and Bloom LLC",
  legalName: "Becoming and Bloom LLC",
  domain: "laurelweb.co",
  siteUrl: "https://laurelweb.co",
  email: "hello@laurelweb.co",
  calendlyUrl: "https://calendly.com/laurelwebco/discovery-call",
  address: {
    careOf: "c/o Becoming and Bloom LLC",
    street: "225 Parkway 575 #896",
    city: "Woodstock",
    state: "GA",
    zip: "30188",
    country: "US"
  },
  analyticsId: process.env.NEXT_PUBLIC_GA_ID || "G-THD8EX5Y88",
  linkedinUrl: "https://linkedin.com/company/laurelwebco",
  instagramUrl: "https://instagram.com/laurelwebco",
  facebookUrl: "https://facebook.com/laurelwebco",
  pinterestUrl: "https://pinterest.com/laurelwebco",
  youtubeUrl: "https://youtube.com/@laurelwebco",
  threadsUrl: "https://threads.net/@laurelwebco",
  blueskyUrl: "https://bsky.app/profile/laurelwebco.bsky.social",
  xUrl: "https://x.com/laurelwebco",
  githubUrl: "https://github.com/laurelwebco",
  gumroadStoreUrl: "",

  defaultOGImage: "/og-default.webp",
  description: "Specialized web design studio dedicated to accessible, high-performance websites for nonprofits, churches, and community-driven organizations.",
};
